import(/* webpackMode: "eager" */ "/opt/build/repo/app/(chat)/community/page.tsx");
